<style lang="scss">
  @import "header";
</style>

<script>
import { mapGetters } from 'vuex'
import { CONSTANT, ACCOUNT_LABELS } from '../../../utils/constant'
import CartDetails from '../../cart-details/cart-details'
import { BPopover } from 'bootstrap-vue'
import sharedService from '../../../utils/shared-service'
import { EventBus } from '@/event-bus'

export default {
  components: {
    'b-popover': BPopover,
    CartDetails
  },
  data () {
    return {
      CONSTANT: CONSTANT,
      active: false,
      accountLabels: ACCOUNT_LABELS
    }
  },

  computed: {
    ...mapGetters(['totalItems', 'consumerInfo', 'consumerBillingAddress', 'enableNativeIntegrationFlow'])
  },
  watch: {
    enableNativeIntegrationFlow (newVal, oldVal) {
      if (newVal === false) {
        this.accountLabels = this.accountLabels.filter(item => item !== 'Payment method')
      } else {
        !this.accountLabels.includes('Payment method') && this.accountLabels.splice(1, 0, 'Payment method')
      }
    }
  },

  created () {
    if (this.enableNativeIntegrationFlow === false) {
      this.accountLabels = this.accountLabels.filter(item => item !== 'Payment method')
    }
  },

  methods: {
    homePage () {
      sharedService.clearStore()
      if (this.$router.history.current.path !== '/') {
        this.$router.push('/').catch(err => { console.error(err) })
      }
    },

    cartPage () {
      this.$router.push('/cart').catch(err => { console.error(err) })
    },

    /**
     * This method will route to account page if the user is not login
     */
    accountPage () {
      if (!this.consumerInfo.firstName) {
        this.routeToAccount()
      }
    },

    /**
     * This method will route to account page
     */
    routeToAccount () {
      if (this.$router.history.current.path !== '/account') {
        this.$router.push('/account').catch(err => { console.error(err) })
      }
    },

    /**
     * This method will store the selected account type as login or profile
     * @param options
     */
    getAccountType (options) {
      this.$store.commit('changeAccountType', options.toLowerCase())
      if (options === 'Sign Out') {
        this.signOut()
      } else if (options === 'Payment method') {
        EventBus.$emit('openConsumer', true)
      } else {
        this.routeToAccount()
      }
    },

    /**
     * This method will clear the consumer name from billing Address section after logout
     */
    handleBillingAddressName () {
      let consumerFullName = this.consumerInfo.firstName && this.consumerInfo.firstName.concat(' ', this.consumerInfo.lastName)
      if (consumerFullName && this.consumerBillingAddress && consumerFullName.localeCompare(this.consumerBillingAddress.name) === 0) {
        this.consumerBillingAddress['name'] = ''
        this.$store.commit('changeConsumerBillingAddress', this.consumerBillingAddress)
      }
    },

    /**
     * This method sign out the login user
     */
    signOut () {
      this.handleBillingAddressName()
      this.$store.commit('changeConsumerInfo', {})
      this.$store.commit('changeNationalIdentifier', '')
      this.$store.commit('changeConsumerJwt', false)
      this.$store.commit('setSelectedSavedCardDetails', null)
      this.$store.commit('setConsumerContactInfo', '')
      sharedService.clearStore()
      this.$router.push('/').catch(err => { console.error(err) })
    }
  }
}
</script>

<template>
  <header class="main-header p-lg-0 container mt-3 mb-2">
    <div class="row">
      <div class="col-6 col-sm-3 pt-4">
        <img
          class="header-logo cursor-pointer"
          src="@/assets/images/header_logo.png"
          @click="homePage()"
        >
      </div>
      <div class="col-6 col-sm-3 order-sm-12 pt-3">
        <div class="btn-group pull-right">
          <div class="dropdown">
            <button
              id="account-page"
              :data-toggle="consumerInfo.firstName?'dropdown':''"
              class="btn btn-lg btn-without-border"
              type="button"
              @click="accountPage()"
            >
              <h5
                v-if="consumerInfo.firstName"
                class="text-white text-capitalize mb-0 mt-2">
                {{ 'Hi, ' + consumerInfo.firstName }}
              </h5>
              <i
                v-else
                class="fa fa-user-circle-o fa-2x" />
            </button>
            <div
              :class="{'d-none':!consumerInfo.firstName}"
              class="dropdown-menu cursor-pointer sign-in-dropdown pb-0 mb-0"
              aria-labelledby="login-dropdown-menu">
              <li
                v-for="(options, index) in accountLabels"
                :key="index"
                class="sign-in-list"
              >
                <h4
                  :id="options"
                  class="dropdown-item pl-3 py-3 mb-0"
                  @click="getAccountType(options)"
                >
                  <label class="m-0 sign-in-labels">{{ options }}</label>
                </h4>
                <hr class="m-0">
              </li>
            </div>
          </div>
          <div class="vl" />
          <div>
            <button
              id="cart-popover"
              class="btn btn-lg btn-without-border"
              type="button"
              @click="cartPage()"
            >
              <i class="fa fa-shopping-cart fa-2x" />
              <span class="badge cart-total">{{ totalItems ? totalItems : 0 }}</span>
            </button>
          </div>
        </div>
        <b-popover
          ref="popover"
          triggers="hover"
          target="cart-popover"
          placement="bottom"
        >
          <cart-details />
        </b-popover>
      </div>

      <div class="col-12 col-sm-6 text-center">
        <h1
          class="header-title font-weight-bold cursor-pointer"
          @click="homePage()"
        >
          {{ CONSTANT.APP_NAME.ABBR }}
        </h1>
        <h5 class="font-weight-bold">
          {{ CONSTANT.APP_NAME.FULL }}
        </h5>
      </div>
    </div>
  </header>
</template>
